import IconBtn from "../IconBtn";
import React, {
  ChangeEventHandler,
  CompositionEventHandler,
  KeyboardEventHandler,
} from "react";
import WaveSurferRecorder from "../WaveSurferRecorder";
import { AttachFile, Mic, Send, Stop } from "@mui/icons-material";

type TProps = {
  isRecording: boolean;
  onClickRecord: () => void;
  onClickSend: (e: string) => void;
  value: string;
  onChange?: ChangeEventHandler<HTMLTextAreaElement>;
  onKeyUp?: KeyboardEventHandler<HTMLTextAreaElement>;
  onKeyDown?: KeyboardEventHandler<HTMLTextAreaElement>;
  onComposition?: CompositionEventHandler<HTMLTextAreaElement>;
  onChangeFile?: ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
  uploadDisabled?: boolean;
};
export const ChatInput = (props: TProps) => {
  return (
    <div className="ChatInput flex relative overflow-hidden p-2">
      <div className="relative flex-grow">
        <textarea
          value={props.value}
          className={`resize-none placeholder:italic placeholder:text-slate-400 block bg-${
            props.disabled || props.isRecording ? "gray-200" : "white"
          } w-full border border-slate-300 rounded-md py-2 pl-3 pr-16 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm`}
          placeholder="傳送訊息"
          onChange={props.onChange}
          onKeyUp={props.onKeyUp}
          onKeyDown={props.onKeyDown}
          onCompositionStart={props.onComposition}
          onCompositionUpdate={props.onComposition}
          onCompositionEnd={props.onComposition}
          disabled={props.disabled || props.isRecording}
        />
        <div className="absolute right-1 top-1 flex">
          {/* <IconBtn
            disabled={
              props.disabled || props.isRecording || props.uploadDisabled
            }
          >
            <label
              htmlFor="file"
              className={`${
                props.disabled || props.isRecording || props.uploadDisabled
                  ? ""
                  : "cursor-pointer"
              }`}
            >
              <AttachFile
                className={`${
                  props.disabled || props.isRecording || props.uploadDisabled
                    ? "text-gray-400"
                    : "text-gray-500"
                }`}
                fontSize="small"
              />
            </label>
            <input
              onChange={props.onChangeFile}
              id="file"
              type="file"
              disabled={
                props.disabled || props.isRecording || props.uploadDisabled
              }
              className="hidden"
              accept=".pdf,.csv"
            />
          </IconBtn> */}
          <IconBtn
            onClick={props.onClickSend}
            disabled={props.disabled || props.isRecording}
          >
            <Send
              className={`${
                props.disabled || props.isRecording
                  ? "text-gray-400"
                  : "text-gray-500"
              }`}
              fontSize="small"
            />
          </IconBtn>
        </div>
      </div>
      <div
        className={`absolute left-0 right-0 top-0 bottom-0 bg-white rounded-2xl transform ${
          props.isRecording || "translate-y-full"
        } transition ease-in-out duration-150`}
      >
        <div className={`p-2 pr-20 ${!props.isRecording && "hidden"}`}>
          <WaveSurferRecorder />
        </div>
      </div>
      {/* <div className="mx-2">
        <button
          onClick={props.onClickRecord}
          className={`group rounded-full w-[40px] h-[40px] flex justify-center items-center relative z-10 
        ${
          props.disabled
            ? "bg-gray-200"
            : "bg-gradient-to-b from-[#537895] to-[#09203f]"
        }`}
          disabled={props.disabled}
        >
          <span
            className={`w-[28px] h-[28px] absolute left-[6px] opacity-0 bg-[#09203f] rounded-full block ${
              props.disabled ||
              "group-hover:animate-ping group-hover:opacity-80"
            }`}
          ></span>
          {props.isRecording ? (
            <Stop
              className={`${
                props.disabled ? "text-gray-400" : "text-white"
              } relative z-10`}
            />
          ) : (
            <Mic
              className={`${
                props.disabled ? "text-gray-400" : "text-white"
              } relative z-10`}
            />
          )}
        </button>
      </div> */}
    </div>
  );
};

export default ChatInput;
